import Image from 'next/image';

export const SabaCoinIcon = () => (
	<Image 
		src="/images/coin-icon.svg" 
		alt=""
		width="16"
		height="16"
	/>
);